// import { Root } from '@radix-ui/react-label';
import styled, { css, keyframes } from 'styled-components';

export const StyledLabel = styled.div`
  color: #12344d;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  display: flex;
  margin-bottom: 4px;
`;

type InputLabelProps = {
  disabled?: boolean;
};

export const InputLabel = styled.label<InputLabelProps>`
  /* font-family: ${({ theme }) => theme.typography.fontFamily}; */
  /* color: ${({ theme, disabled }) =>
    disabled ? theme.colors.text.disabled : theme.colors.text.primary}; */
  margin: 0 8px;
  display: inline-flex;
  /* font-weight: ${({ theme }) => theme.typography.fontWeight['semi-bold']};
  font-size: ${({ theme }) => theme.typography.secondary.fontSize};
  line-height: ${({ theme }) => theme.typography.secondary.lineHeight}; */
  display: flex;
`;

export const IconButton = styled.button`
  margin: 0;
  padding: 0;
  width: 20px;
  height: 20px;
  border: none;
  background: none;
  cursor: pointer;
`;

export const FreshLink = styled.a`
  /* font-weight: ${({ theme }) => theme.typography.fontWeight['semi-bold']};
  font-size: ${({ theme }) => theme.typography.primary.fontSize};
  line-height: ${({ theme }) => theme.typography.primary.lineHeight};
  color: ${({ theme }) => theme.colors.text.link};
  font-family: ${({ theme }) => theme.typography.fontFamily}; */
  text-decoration: unset;
  :hover {
    text-decoration: underline;
  }
`;

export const TriggerButtonWrapper = styled.button`
  border: none;
  padding: 0;
  margin: 0;
  width: fit-content;
  background: inherit;
  cursor: pointer;
  display: grid;
  place-content: center;
`;

const basicHideKeyframes = keyframes`
 from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
`;

export const basicHide = () => css`
  ${basicHideKeyframes}
`;

const basicShowKeyframes = keyframes`
 from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

export const basicShow = () => css`
  ${basicShowKeyframes}
`;

const contentHideKeyframes = keyframes`
  from {
    opacity: 1;
    transform: translate(-50%, 0%) scale(1);
  }
  to {
    opacity: 0;
    transform: translate(-50%, -16px) scale(0.96);
  }
`;

export const contentHide = () => css`
  ${contentHideKeyframes}
`;

const contentShowKeyframes = keyframes`
  from {
    opacity: 0;
    transform: translate(-50%, -16px) scale(0.96);
  }
  to {
    opacity: 1;
    transform: translate(-50%, 0%) scale(1);
  }
`;

export const contentShow = () => css`
  ${contentShowKeyframes}
`;

const slideUpAndFadeKeyframes = keyframes`
  from {
    opacity: 0;
    transform: translateY(2px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const slideUpAndFade = () => css`
  ${slideUpAndFadeKeyframes}
`;

const slideRightAndFadeKeyframes = keyframes`
 from {
    opacity: 0;
    transform: translateX(-2px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
`;

export const slideRightAndFade = () => css`
  ${slideRightAndFadeKeyframes}
`;

const slideDownAndFadeKeyframes = keyframes`
 from {
    opacity: 0;
    transform: translateY(-2px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const slideDownAndFade = () => css`
  ${slideDownAndFadeKeyframes}
`;

const slideLeftAndFadeKeyframes = keyframes`
  from {
    opacity: 0;
    transform: translateX(2px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
`;

export const slideLeftAndFade = () => css`
  ${slideLeftAndFadeKeyframes}
`;
